import type { RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import TransactionsIndex from '@/views/transactions/index.vue'
import TransactionDetails from '@/views/transactions/transaction-details.vue'

const transactionsRoutes: RouteRecordRaw[] = [
  {
    path: '/transactions',
    meta: { layout: DefaultLayout, middleware: ['auth'] },
    children: [
      { path: '', name: 'Transactions', component: TransactionsIndex },
      { path: ':id', name: 'Transaction-Details', component: TransactionDetails, props: true },
    ],
  },
]

export default transactionsRoutes
